import PropTypes from "prop-types";
import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";

import { userRoutes, authRoutes } from "./routes/allRoutes";
import Authmiddleware from "./routes/middleware/Authmiddleware";

import "./assets/scss/theme.scss";
import "./assets/scss/preloader.scss";

const VerticalLayout = lazy(() => import("./components/VerticalLayout/"));
const HorizontalLayout = lazy(() => import("./components/HorizontalLayout/"));
const NonAuthLayout = lazy(() => import("./components/NonAuthLayout"));

const RouteLoader = () => (
    <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh", background: "#0f172a" }}
    >
      <div className="text-center text-white">
        <Spinner />
        <div className="mt-3">Loading ExchangeOS...</div>
      </div>
    </div>
);

const App = props => {
  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  return (
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          {authRoutes.map((route, idx) => (
              <Route
                  path={route.path}
                  element={
                    <NonAuthLayout>
                      {route.component}
                    </NonAuthLayout>
                  }
                  key={idx}
              />
          ))}

          {userRoutes.map((route, idx) => (
              <Route
                  path={route.path}
                  element={
                    <Authmiddleware>
                      <Layout>{route.component}</Layout>
                    </Authmiddleware>
                  }
                  key={idx}
              />
          ))}
        </Routes>
      </Suspense>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);